/* eslint-disable no-prototype-builtins */
/* eslint-disable react/prop-types */
/* eslint-disable max-len */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import clone from 'clone';
import { connect } from 'react-redux';
import _ from 'lodash';
import { numericRange } from '@mhub/web-validations';
import {
  Button,
  Form,
  FormField,
  Grid,
  Header,
  Icon,
  Label,
  Modal,
  Segment,
} from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import moment from 'moment-timezone';
// actions
import { flashErrorMessage } from '../../actions/flash';
// components
import { NoteEditor } from '../../components/BookingNote';
import AppForm from '../../components/AppForm';
import CurrencySymbol from '../../components/CurrencySymbol';
import LoanAmount from '../../components/LoanAmount';
// constants
import { namespaces, TRANSLATION_FILES } from '../../constants/translation';
import BOOKING_STATUSES from '../../constants/bookingStatuses';
// types
import { BookingNoteDefault } from '../../types/index';
// utils
import { getFinanceSourceLabel } from '../../utils/financeSource';
import { translateModels } from '../../utils/translation';
import CalendarDatePicker from '../../components/CalendarDatePicker';
import { toSentenceFromList } from '../../utils/strings';
import { spaFullNumber } from '../../utils/amount';
import { bankCaseOverridesLoanAmount } from '../../utils/creditControl';
import { vnChangeUnitReleasesOldUnit } from '../../utils/vietnam';

const inputDateFormat = 'DD/MM/YYYY';

class BookingStatusNotes extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    isCancelPending: PropTypes.bool,
    isUserCooldown: PropTypes.bool,
    isUnitChange: PropTypes.bool,
    isDelistOnHold: PropTypes.bool,
    statusID: PropTypes.string.isRequired,
    headerNode: PropTypes.node,
    onNotesChange: PropTypes.func.isRequired,
    onCheckboxChange: PropTypes.func.isRequired,
    data: PropTypes.shape({
      paymentMethodID: PropTypes.string,
    }),
    appConfig: PropTypes.shape({
      data: PropTypes.shape({
        settings: PropTypes.shape({
          unitCooldownIsEnabled: PropTypes.bool,
          disableSoldDateSelection: PropTypes.bool,
          notesExternalPlaceholder: PropTypes.string,
        }),
      }),
    }),
    auth: PropTypes.shape({
      isHeadquarters: PropTypes.bool,
      isAdminBasic: PropTypes.bool,
      isSuperAdmin: PropTypes.bool,
      isDeveloper: PropTypes.bool,
      companyBranch: PropTypes.shape({
        isExternal: PropTypes.bool,
      }),
    }),
    cancellationReasons: PropTypes.shape({
      data: PropTypes.array,
    }),
    financeSources: PropTypes.shape({
      data: PropTypes.array,
    }),
    t: PropTypes.func,
  }
  static mapStateToProps = state => ({
    appConfig: state.appConfig,
    auth: state.auth,
    cancellationReasons: state.cancellationReasons,
    financeSources: state.financeSources,
  })
  static contextTypes = {
    store: PropTypes.object,
  }
  static getPropsToState = (props) => {
    const data = props.data;
    const paymentMethods = [];

    let loanMargin = 0;
    let selectedBankID = null;
    let cancelReason = '';

    if (data) {
      if (data.loanAmount > 0) {
        loanMargin = Math.ceil((data.loanAmount / parseFloat(spaFullNumber(data))) * 100);
      }
      if (data.selectedBankCaseID) {
        selectedBankID = data.selectedBankCaseID === 0 && !data.loanAmount
          ? null
          : data.selectedBankCaseID;
      }
    // set cancellation reason
      let defaultReasonID = 'cancelled_by_developer';
      const defaultCUReasonOrder = {
        transfer_of_parcel: 1,
        change_of_unit_default: 2,
      };
      const orderedCUReasons = props.cancellationReasons.data
      .filter(item => defaultCUReasonOrder.hasOwnProperty(item.id))
      .sort((a, b) => defaultCUReasonOrder[a.id] - defaultCUReasonOrder[b.id]);
      const defaultCUReasonID = orderedCUReasons.length > 0 ? orderedCUReasons[0].id : '';
      if (props.isUnitChange && defaultCUReasonID) {
        defaultReasonID = defaultCUReasonID;
      }
      cancelReason = data.cancellationReasonID || defaultReasonID;
    }
    return {
      data,
      oriData: clone(data),
      soldDatePickVisible: false,
      spaSigningDatePickVisible: false,
      spaStampingDatePickVisible: false,
      minSoldDate: null,
      paymentMethods,
      loanMargin,
      // Lets the user empty the Loan Amount input; loanAmount itself stays numeric (0)
      loanAmountCleared: false,
      selectedBankID,
      cancelReason,
      bookedDatePickVisible: false,
      minBookedDate: null,
    };
  }
  constructor(props) {
    super(props);
    const state = BookingStatusNotes.getPropsToState(props);
    const cancellationReasons = props.cancellationReasons ?
      [].concat(props.cancellationReasons.data) : [];
    this.state = {
      ...state,
      cancellationReasons,
    };
  }
  componentWillReceiveProps(nextProps) {
    const state = BookingStatusNotes.getPropsToState(nextProps);
    const cancellationReasons = nextProps.cancellationReasons ?
      [].concat(nextProps.cancellationReasons.data) : this.state.cancellationReasons;
    if (this.checkStringify(state.oriData, this.state.oriData)) {
      state.data = this.state.data;
    }
    state.loanAmountCleared = this.state.loanAmountCleared
      && !(nextProps.open && !this.props.open)
      && !(state.data && state.data.loanAmount);

    if (
      state
      && state.data
      && state.data.newBookingNoteEncoded
      && this.state
      && this.state.oriData
      && this.state.oriData.newBookingNoteEncoded
      && state.data.newBookingNoteEncoded !== this.state.oriData.newBookingNoteEncoded
    ) {
      state.selectedBankID = this.state.selectedBankID;
    }

    const financeSources = nextProps.financeSources;
    if (state.data && state.data.project && state.data.project.sourceOfFinanceOptions && financeSources.data && financeSources.data.length > 0) {
      const paymentOptions = [];
      state.data.project.sourceOfFinanceOptions.forEach((f) => {
        paymentOptions.push({ text: getFinanceSourceLabel(f, financeSources.data), value: f });
      });
      state.paymentMethods = paymentOptions;
    }
    this.setState({
      ...state,
      cancellationReasons,
    });
  }
  componentDidUpdate(prevProps) {
    if (!prevProps.open && this.props.open) {
      this.bookingDatesSetValues();
    }
  }
  getPercentageOptions = () => {
    let options = [];
    for (let i = 100; i >= 0; i -= 1) {
      options = [...options, {
        key: i,
        value: i,
        text: `${i}%`,
      }];
    }
    return options;
  }
  getValueText = (value) => {
    const { t } = this.props;
    const valueName = BOOKING_STATUSES.find(vn => vn.value === value);
    if (valueName && valueName.text) {
      return t(valueName.text, { ns: TRANSLATION_FILES.constants });
    }
    return '';
  }
  hasAccess(check = false, admin = true, dhq = true, dbl = true, internal = false) {
    const auth = this.props.auth;
    if (dbl && this.props.auth.isBranchLeader) {
      return true;
    }
    if (dhq && this.props.auth.isHeadquarters) {
      return true;
    }
    if (admin && this.props.auth.isSuperAdmin) {
      return true;
    }
    if (internal && auth && auth.companyBranch && !auth.companyBranch.isExternal) {
      return true;
    }
    return check;
  }
  checkStringify = (source, target) => JSON.stringify(source) === JSON.stringify(target)
  bankCasesList = () => {
    const { data } = this.state;
    const { t } = this.props;
    let bankCases = [];

    if (data.bankCases.length > 0) {
      bankCases = data.bankCases.reduce((r, bc) => {
        if (bc.status && !bc.status.startsWith('reject')) {
          r.push({
            key: bc.id,
            value: bc.id,
            text: bc.bank.name,
          });
        }
        return r;
      }, []);

      return [...bankCases, {
        key: 'others',
        value: 0,
        text: t('Others', { ns: TRANSLATION_FILES.constants }),
      }];
    }

    return [...bankCases, {
      key: 'others',
      value: 0,
      text: t('Others', { ns: TRANSLATION_FILES.constants }),
    }];
  }
  bookingDatesSetValues = () => {
    const { data } = this.state;
    const isBooked = this.props.statusID === 'booked';
    const isSold = this.props.statusID === 'sold_spa_signed';

    // Set date for date pickers
    if (isBooked) {
      data.approvedAt = data.approvedAt ? data.approvedAt : moment().toDate();
    } else if (isSold) {
      data.lastSoldAt = data.lastSoldAt ? data.lastSoldAt : moment().toDate();
    }
    this.setState({ data });
  }
  handleOnVisible = (name) => {
    const { data } = this.state;
    const updatedState = { ...this.state };
    const minDate = data.createdAt ? moment(data.createdAt).startOf('day').toDate() : null;

    // set minDate for date pickers
    if (name === 'approvedAt') {
      updatedState.minBookedDate = minDate;
    } else {
      updatedState.minSoldDate = minDate;
    }

    // Set visibility for date pickers
    if (name === 'lastSoldAt') {
      updatedState.soldDatePickVisible = true;
    } else if (name === 'spaSigningDate') {
      updatedState.spaSigningDatePickVisible = true;
    } else if (name === 'spaStampingDate') {
      updatedState.spaStampingDatePickVisible = true;
    } else if (name === 'approvedAt') {
      updatedState.bookedDatePickVisible = true;
    }

    this.setState(updatedState);
  }
  handleOnClear = (field) => {
    const { data } = this.state;
    data[field] = null;
    this.setState({ data });
  }
  handleDateChanges = (value, visible, name, pickerField) => {
    const { data } = this.state;
    // Set the respective booking date based on input.
    data[name] = value;
    this.setState({ data, [pickerField]: visible });
  }
  handleOnClose = (e) => {
    if (this.props.onClose) {
      this.props.onClose(e);
    }
  }
  handleOnConfirm = (e, data, bankCaseID) => {
    e.preventDefault();
    const { t } = this.props;
    const bookingData = data;
    const isBooked = this.props.statusID === 'booked';
    const isSold = this.props.statusID === 'sold_spa_signed';
    const isCancelled = this.props.statusID === 'cancelled_developer';
    const unitData = bookingData ? bookingData.projectUnit : null;
    const unitBookingSummary = unitData ? unitData.projectUnitBookingSummary : null;
    const holdUnitFailed = unitData && unitData.delistOnHold && unitBookingSummary && (unitBookingSummary.bookedCount + unitBookingSummary.reservedCount + unitBookingSummary.soldCount) > 1;

    if (bookingData.newBookingNoteEncoded === '' ||
      (isSold && bookingData.paymentMethodID !== 'cash' && !bankCaseID && bankCaseID !== 0) ||
      (isBooked && !bookingData.approvedAt) ||
      (isSold && !bookingData.lastSoldAt) ||
      (bookingData.paymentMethodID !== 'cash' && bookingData.selectedBankCaseID !== 0 && (bookingData.loanAmount <= 0 || bookingData.loanAmount > parseFloat(spaFullNumber(bookingData)))) ||
    holdUnitFailed) {
      const { store } = this.context;
      let message = '';
      const missingFields = [];
      if (isBooked) {
        if (!bookingData.approvedAt) {
          missingFields.push(translateModels(t, 'approvedAt', 'booking'));
        }
        if (bookingData.newBookingNoteEncoded === '') {
          missingFields.push(t('Notes'));
        }
        message = `${toSentenceFromList(missingFields)} required`;
      } else if (isSold) {
        if (!bookingData.lastSoldAt) {
          missingFields.push(translateModels(t, 'lastSoldAt', 'booking'));
        }
        if (!bankCaseID) {
          missingFields.push(t('Bank'));
        }
        if (bookingData.paymentMethodID !== 'cash' && bookingData.selectedBankCaseID !== 0 && bookingData.loanAmount <= 0) {
          missingFields.push(t('Loan Amount'));
        }
        if (bookingData.newBookingNoteEncoded === '') {
          missingFields.push(t('Notes'));
        }
        if (bookingData.loanAmount > parseFloat(spaFullNumber(bookingData))) {
          message = 'Loan Amount must be less than Selling Price';
        }
      } else if (bookingData.newBookingNoteEncoded === '') {
        missingFields.push(t('Notes'));
      } else if (holdUnitFailed) {
        message = 'There is another active reservation for this unit. Cannot change status to On Hold.';
      } else {
        message = 'Loan Amount must be more than 0';
      }
      if (missingFields.length > 0) {
        message = `${toSentenceFromList(missingFields)} required`;
      }
      store.dispatch(flashErrorMessage({
        header: t('Please fix form errors', { ns: TRANSLATION_FILES.translation }),
        message: t(message, { ns: TRANSLATION_FILES.translation }),
      }));
    } else if (this.props.onConfirm) {
      if (this.props.statusID === 'sold_spa_signed') {
        bookingData.isCancelPending = false;
        bookingData.isUserCooldown = false;
        bookingData.projectUnit.delistOnHold = false;
      }
      if ((!bankCaseID || bankCaseID === 0) && !data.loanAmount) {
        bookingData.selectedBankCaseID = 0;
      }
      if (isCancelled) {
        bookingData.cancellationReasonID = this.state.cancelReason;
      }
      if (data.lastSoldAt) {
        bookingData.lastSoldAt = data.lastSoldAt;
      }
      this.props.onConfirm(e, bookingData);
    }
  }
  handleAmountChange = (e, d) => {
    const { data, loanMargin } = this.state;
    let loanPercent = loanMargin;
    if (d.name === 'loanAmount') {
      let amount = 0;
      if (d.value !== '') {
        amount = parseFloat(d.value);
      }
      loanPercent = Math.ceil((amount / parseFloat(spaFullNumber(data))) * 100);
      data.loanAmount = amount;
      // React won't rewrite a number input whose text loosely equals the state ("01100" == 1100),
      // so typing after the initial 0 would keep showing the leading zero
      if (/^0+\d/.test(d.value)) {
        const input = e.target;
        input.value = d.value.replace(/^0+(?=\d)/, '');
      }
    }
    this.setState({ data, loanMargin: loanPercent, loanAmountCleared: d.value === '' });
  }
  handleNotesChange = (bnEncoded) => {
    if (this.props.onNotesChange) {
      this.props.onNotesChange(bnEncoded);
    }
  }
  handleCheckboxChange = (e, value) => {
    if (this.props.onCheckboxChange) {
      this.props.onCheckboxChange(e, value);
    }
  }
  handleChange = (e, d) => {
    const { data } = this.state;
    if (d.name === 'bankName' && d.value !== '') {
      data.selectedBankCaseID = 0;
    }
    data[d.name] = d.value;

    this.setState({ data });
  }
  handleSelectChange = (e, d) => {
    const { data } = this.state;
    let { loanMargin, selectedBankID, cancelReason, loanAmountCleared } = this.state;
    if (d.name === 'selectedBankCaseID') {
      if (data.selectedBankCaseID !== d.value) {
        data.bankerName = '';
        data.bankName = '';
      }
      if (data.bankCases.length > 0 && d.value !== 0) {
        const selectedBankCase = data.bankCases.find(bc => bc.id === d.value);
        data.bankerName = selectedBankCase.banker.name;
        // With Credit Control linked the booking's loan amount is the value it synced (0 after a
        // loan cancellation), so the bank case must not put its own amount back on the booking.
        if (bankCaseOverridesLoanAmount(this.props.appConfig, data.project)) {
          data.loanAmount = parseFloat(selectedBankCase.loanAmount);
          loanAmountCleared = false;
        }
        loanMargin = data.loanAmount > 0
          ? Math.ceil((data.loanAmount / parseFloat(spaFullNumber(data))) * 100)
          : 0;
      }
      selectedBankID = d.value;
    } else if (d.name === 'loanMargin') {
      loanMargin = _.toNumber(d.value);
      data.loanAmount = parseFloat(((loanMargin / 100) * parseFloat(spaFullNumber(data))).toFixed(2));
      loanAmountCleared = false;
    } else if (d.name === 'cancellationReasonID') {
      cancelReason = d.value;
    }
    data[d.name] = d.value;
    this.setState({
      data,
      loanMargin,
      loanAmountCleared,
      selectedBankID,
      cancelReason,
    });
  }
  showCooldown() {
    const appConfig = this.props.appConfig.data;
    const { auth } = this.props;
    const hasAccess = auth.isHeadquarters || auth.isAdminBasic || auth.isSuperAdmin;
    return hasAccess && appConfig && appConfig.settings && appConfig.settings.unitCooldownIsEnabled;
  }
  checkCuByAgent() {
    const { auth, isUnitChange } = this.props;
    if (auth &&
    auth.companyBranch &&
    auth.companyBranch.isExternal &&
    auth.isDeveloper &&
    !auth.isSuperAdmin &&
    !auth.isHeadquarters &&
    !auth.isBranchLeader) {
      return isUnitChange;
    }
    return false;
  }
  hideCancelCriteria() {
    const { data } = this.state;
    if (this.checkCuByAgent() && data.project && data.project.cuDisableExtEditCancelCriteria) {
      return true;
    }
    return false;
  }
  renderHeader = () => {
    const { headerNode, t } = this.props;
    if (headerNode) return headerNode;
    if (this.checkCuByAgent()) return t('Change Unit');
    return `${t('Change status to {{status}}', { status: this.getValueText(this.props.statusID) })}?`;
  }
  renderCancelContent = () => {
    const { t, auth, isUnitChange } = this.props;
    // CPI-1464: a Vietnamese Change Unit never keeps the old unit on hold, so the box is not offered.
    const hideDelistOnHold = isUnitChange && vnChangeUnitReleasesOldUnit(auth);
    return (
      <Form className="cancel_options">
        <FormField>
          <b>Cancellation Criteria</b>
        </FormField>
        <Form.Checkbox
          name="isCancelPending"
          label={translateModels(t, 'isCancelPending', 'booking')}
          checked={this.props.isCancelPending}
          onChange={this.handleCheckboxChange}
        />
        {!hideDelistOnHold && (
          <Form.Checkbox
            name="delistOnHold"
            label={translateModels(t, 'delistOnHold', 'booking')}
            checked={this.props.isDelistOnHold}
            onChange={this.handleCheckboxChange}
          />
        )}
        {
          this.showCooldown() && (
            <Form.Checkbox
              name="isUserCooldown"
              label={translateModels(t, 'isUserCooldown', 'booking')}
              checked={this.props.isUserCooldown}
              onChange={this.handleCheckboxChange}
            />
          )
        }
      </Form>
    );
  }
  renderCancelActions = () => (
    <Grid>
      <Grid.Row>
        <Grid.Column mobile={16} computer={16}>
          {this.renderActionButtons()}
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
  renderActionButtons = () => {
    const { t, auth, isUnitChange } = this.props;
    const { data, selectedBankID } = this.state;
    // Hide Cancel button for Agent/Staff during unit change (only show for HQ)
    const showCancelButton = !isUnitChange || (auth && auth.isHeadquarters);
    return (
      <Grid.Row>
        {showCancelButton && (
          <Button negative onClick={this.handleOnClose} icon="cancel" content={t('Cancel', { ns: TRANSLATION_FILES.translation })} />
        )}
        <Button
          positive
          onClick={e => this.handleOnConfirm(e, data, selectedBankID)}
          icon="checkmark"
          content={t('Confirm', { ns: TRANSLATION_FILES.translation })}
          data-bot-target="confirm"
        />
      </Grid.Row>
    );
  }
  renderStatusModal = (data, loanMargin, selectedBankID, cancellationReasons, cancelReason) => {
    const { t, appConfig } = this.props;
    const isBooked = this.props.statusID === 'booked';
    const isSold = this.props.statusID === 'sold_spa_signed';
    const isCancelled = this.props.statusID === 'cancelled_developer';
    const allowSelectingSoldDate = appConfig && appConfig.data && appConfig.data.settings && !appConfig.data.settings.disableSoldDateSelection;

    if (data && isBooked) {
      return (
        <div>
          <p>{t('Please fill in details')}</p>
          <Form>
            <Grid.Row style={{ marginTop: '1.2em' }}>
              <b>{`${translateModels(t, 'approvedAt', 'booking')}*`}</b>
              <Form.Input
                fluid
                placeholder={t('Click to set booking date')}
                value={data.approvedAt ? moment(data.approvedAt).format(inputDateFormat) : ''}
                readOnly
                onFocus={() => this.handleOnVisible('approvedAt')}
                icon={
                  data.approvedAt ?
                    <Icon
                      color="red"
                      link
                      name="x"
                      onClick={() => this.handleOnClear('approvedAt')}
                      title={t('Clear')}
                    />
                  : 'calendar'
                }
                style={{ marginTop: '0.2em', marginBottom: '0.9em' }}
                width={8}
              />
            </Grid.Row>
            <Grid>
              <Grid.Column width={8}>
                <CalendarDatePicker
                  closeableCompact={false}
                  minDate={this.state.minBookedDate}
                  maxDate={moment().toDate()}
                  noPadding
                  name="approvedAt"
                  value={data.approvedAt ? moment(data.approvedAt).toDate() : null}
                  onChange={(value, visible) => this.handleDateChanges(value, visible, 'approvedAt', 'bookedDatePickVisible')}
                  visible={this.state.bookedDatePickVisible}
                />
              </Grid.Column>
            </Grid>
            <b>{t('Notes')}* ({t('Required').toLowerCase()})</b>
            <NoteEditor
              bookingNote={{ ...BookingNoteDefault }}
              hideCustomOptions
              onUpdate={this.handleNotesChange}
              auth={this.props.auth}
              settings={this.props.appConfig && this.props.appConfig.data && this.props.appConfig.data.settings}
            />
          </Form>
        </div>
      );
    } else if (data && isSold) {
      return (
        <div>
          <p>{t('Please fill in details')}</p>
          <Form>
            <Grid>
              <Grid.Column width={8}>
                <Grid.Row style={{ marginTop: '1.2em' }}>
                  <b>{`${translateModels(t, 'lastSoldAt', 'booking')}*`}</b>
                  <Form.Input
                    fluid
                    placeholder={t('Click to set sold at date')}
                    value={data.lastSoldAt ? moment(data.lastSoldAt).format(inputDateFormat) : ''}
                    disabled={!allowSelectingSoldDate}
                    readOnly
                    onFocus={() => this.handleOnVisible('lastSoldAt')}
                    icon={
                      data.lastSoldAt ?
                        <Icon
                          color="red"
                          link
                          name="x"
                          onClick={() => this.handleOnClear('lastSoldAt')}
                          title={t('Clear')}
                        />
                      : 'calendar'
                    }
                  />
                </Grid.Row>
              </Grid.Column>
            </Grid>
            {
              allowSelectingSoldDate ?
              (
                <Grid style={{ marginTop: '-1rem' }}>
                  <Grid.Column width={8}>
                    <CalendarDatePicker
                      closeableCompact={false}
                      minDate={this.state.minSoldDate}
                      maxDate={moment().toDate()}
                      noPadding
                      name="lastSoldAt"
                      value={data.lastSoldAt ? moment(data.lastSoldAt).toDate() : null}
                      onChange={(value, visible) => this.handleDateChanges(value, visible, 'lastSoldAt', 'soldDatePickVisible')}
                      visible={this.state.soldDatePickVisible}
                    />
                  </Grid.Column>
                </Grid>
              ) : null
            }
            <Grid style={{ marginTop: '-1.5rem' }}>
              <Grid.Column width={8}>
                <Grid.Row >
                  <b>{translateModels(t, 'spaSigningDate', 'booking')}</b>
                  <Form.Input
                    fluid
                    placeholder={t('Click to set SPA signing date')}
                    value={data.spaSigningDate ? moment(data.spaSigningDate).format(inputDateFormat) : ''}
                    disabled={!allowSelectingSoldDate}
                    readOnly
                    onFocus={() => this.handleOnVisible('spaSigningDate')}
                    icon={
                      data.spaSigningDate ?
                        <Icon
                          color="red"
                          link
                          name="x"
                          onClick={() => this.handleOnClear('spaSigningDate')}
                          title={t('Clear')}
                        />
                      : 'calendar'
                    }
                  />
                </Grid.Row>
              </Grid.Column>
              <Grid.Column width={8}>
                <Grid.Row>
                  <b>{translateModels(t, 'spaStampingDate', 'booking')}</b>
                  <Form.Input
                    fluid
                    placeholder={t('Click to set SPA stamping date')}
                    value={data.spaStampingDate ? moment(data.spaStampingDate).format(inputDateFormat) : ''}
                    disabled={!allowSelectingSoldDate}
                    readOnly
                    onFocus={() => this.handleOnVisible('spaStampingDate')}
                    icon={
                      data.spaStampingDate ?
                        <Icon
                          color="red"
                          link
                          name="x"
                          onClick={() => this.handleOnClear('spaStampingDate')}
                          title={t('Clear')}
                        />
                      : 'calendar'
                    }
                  />
                </Grid.Row>
              </Grid.Column>
            </Grid>
            <Grid style={{ marginTop: '-1rem' }}>
              <Grid.Column width={8}>
                <CalendarDatePicker
                  closeableCompact={false}
                  minDate={this.state.minSoldDate}
                  maxDate={moment().toDate()}
                  noPadding
                  name="spaSigningDate"
                  value={data.spaSigningDate ? moment(data.spaSigningDate).toDate() : null}
                  onChange={(value, visible) => this.handleDateChanges(value, visible, 'spaSigningDate', 'spaSigningDatePickVisible')}
                  visible={this.state.spaSigningDatePickVisible}
                />
              </Grid.Column>
              <Grid.Column width={8}>
                <CalendarDatePicker
                  closeableCompact={false}
                  minDate={this.state.minSoldDate}
                  maxDate={moment().toDate()}
                  noPadding
                  name="spaStampingDate"
                  value={data.spaStampingDate ? moment(data.spaStampingDate).toDate() : null}
                  onChange={(value, visible) => this.handleDateChanges(value, visible, 'spaStampingDate', 'spaStampingDatePickVisible')}
                  visible={this.state.spaStampingDatePickVisible}
                />
              </Grid.Column>
            </Grid>
            <Grid>
              <Grid.Row className="booking-sold-status-info" columns={2}>
                <Grid.Column>
                  <Grid.Row>
                    <b>{translateModels(t, 'paymentMethodID', 'booking')}</b>
                  </Grid.Row>
                  <Grid.Row>
                    {data && data.paymentMethod ? t(data.paymentMethod.name, { ns: TRANSLATION_FILES.constants, defaultValue: data.paymentMethod.name }) : '-'}
                  </Grid.Row>
                </Grid.Column>
                <Grid.Column>
                  <Grid.Row>
                    <b>{translateModels(t, 'spaValue', 'booking')}</b>
                  </Grid.Row>
                  <Grid.Row>
                    <LoanAmount
                      projectCurrencies={data && data.project && data.project.projectCurrency ? data.project.projectCurrency : []}
                      format="0,000,000.00"
                      amount={spaFullNumber(data)}
                      prefix={<CurrencySymbol />}
                    />
                  </Grid.Row>
                </Grid.Column>
              </Grid.Row>
            </Grid>
            {
              data.paymentMethodID !== 'cash' ? (
                <div>
                  {
                    data.bankCases.length < 1 || data.selectedBankCaseID === 0 ? (
                      <div>
                        <Form.Select
                          fluid
                          label={`${t('Bank')}*`}
                          name="selectedBankCaseID"
                          options={this.bankCasesList()}
                          placeholder={t('Please select')}
                          selectOnBlur={false}
                          value={selectedBankID}
                          onChange={this.handleSelectChange}
                        />
                        <Form.Group widths="equal">
                          <Form.Input
                            name="bankName"
                            label={translateModels(t, 'bankName', 'booking')}
                            value={data.bankName}
                            onChange={this.handleChange}
                          />
                          <Form.Input
                            className="booking-sold-status-banker-name"
                            name="bankerName"
                            label={translateModels(t, 'bankerName', 'booking')}
                            value={data.bankerName}
                            onChange={this.handleChange}
                            disabled={data.bankCases.length > 0 && data.selectedBankCaseID !== 0}
                          />
                        </Form.Group>
                      </div>
                    ) : (
                      <Form.Group widths="equal">
                        <Form.Select
                          fluid
                          label={`${t('Bank')}*`}
                          name="selectedBankCaseID"
                          options={this.bankCasesList()}
                          placeholder={t('Please select')}
                          selectOnBlur={false}
                          value={selectedBankID}
                          onChange={this.handleSelectChange}
                        />
                        <Form.Input
                          className="booking-sold-status-banker-name"
                          name="bankerName"
                          label={translateModels(t, 'bankerName', 'booking')}
                          value={data.bankerName}
                          onChange={this.handleChange}
                          disabled={data.bankCases.length > 0 && data.selectedBankCaseID !== 0}
                        />
                      </Form.Group>
                    )
                  }
                  <Form.Group widths="equal">
                    <Form.Select
                      fluid
                      search
                      label={t('Loan Margin')}
                      name="loanMargin"
                      options={this.getPercentageOptions()}
                      placeholder="0%"
                      selectOnBlur={false}
                      value={loanMargin}
                      onChange={this.handleSelectChange}
                      openOnFocus={false}
                      onOpen={() => {
                        // this function is to make dropdown scroll to top when open (only when value is 0)
                        if (loanMargin === 0) {
                          setTimeout(() => {
                            let menu = document.querySelector('.ui.dropdown .menu.visible, .menu.transition.visible');
                            if (!menu) menu = document.querySelector('.menu.visible');
                            if (menu) {
                              // scroll to top
                              menu.scrollTop = 0;
                            }
                          }, 0);
                        }
                      }}
                    />
                    <AppForm.Input
                      name="loanAmount"
                      label={`${t('Loan Amount')} ${data.selectedBankCaseID !== 0 ? '*' : ''}`}
                      type="number"
                      min="0"
                      value={this.state.loanAmountCleared ? '' : data.loanAmount}
                      onChange={this.handleAmountChange}
                      step="0.01"
                      validation={[
                        (v, o) => numericRange(v, {
                          ...o,
                          min: 0,
                          max: parseFloat(spaFullNumber(data)),
                        }),
                      ]}
                    />
                  </Form.Group>
                </div>
              ) : null
            }
            <b>{t('Notes')}* ({t('Required').toLowerCase()})</b>
            <NoteEditor
              bookingNote={{ ...BookingNoteDefault }}
              hideCustomOptions
              onUpdate={this.handleNotesChange}
              auth={this.props.auth}
              settings={this.props.appConfig && this.props.appConfig.data && this.props.appConfig.data.settings}
            />
          </Form>
          { data.project && !data.project.allowPurchaserEditAfterSold && (
            <Segment className="booking-sold-notice">
              <div className="title">
                <Icon>
                  <img
                    alt="info" src="/assets/icons/info_blue.svg" style={{ width: '16px', height: '16px' }}
                  />
                </Icon>
                <strong>Important: Please ensure all information is accurate before proceeding</strong>
              </div>
              <div className="content">
                Once a booking is sold, purchaser details, pricing, and discounts can no longer be edited.
              </div>
            </Segment>
          )}
        </div>
      );
    }
    return (
      <div>
        <p>{t('Please fill in details')}</p>
        <Form>
          {this.props.statusID === 'cancelled_developer' &&
          <div style={{ marginBottom: '1.5em' }}>
            <b>
              {this.checkCuByAgent() ? t('Reason') : translateModels(t, 'cancellationReasonID', 'booking')}
              * ({t('Required').toLowerCase()})
            </b>
            <Form.Select
              style={{ marginTop: '1em' }}
              fluid
              name="cancellationReasonID"
              options={cancellationReasons && cancellationReasons.map(d => ({
                text: d.name,
                value: d.id,
              }))}
              selectOnBlur={false}
              value={cancelReason}
              onChange={this.handleSelectChange}
              disabled={this.checkCuByAgent()}
            />
          </div>
        }
          <b>{t('Notes')}* ({t('Required').toLowerCase()})</b>
          <NoteEditor
            bookingNote={{ ...BookingNoteDefault }}
            hideCustomOptions
            onUpdate={this.handleNotesChange}
            auth={this.props.auth}
            settings={this.props.appConfig && this.props.appConfig.data && this.props.appConfig.data.settings}
          />
        </Form>
        {isCancelled && !this.hideCancelCriteria() && this.renderCancelContent()}
      </div>
    );
  }
  render() {
    const { data, loanMargin, selectedBankID, cancellationReasons, cancelReason } = this.state;
    const { t } = this.props;
    const isBooked = this.props.statusID === 'booked';
    const isSold = this.props.statusID === 'sold_spa_signed';
    const isCancelled = this.props.statusID === 'cancelled_developer';
    return (
      <Modal
        className="booking-status-note"
        open={this.props.open === true}
        onClose={this.handleOnClose}
        closeOnDimmerClick={false}
        size="small"
      >
        <Header icon="file text outline" content={this.renderHeader()} />
        <Modal.Content>
          <Modal.Description style={isSold || isBooked ? { paddingBottom: '1em' } : null}>
            {this.renderStatusModal(data, loanMargin, selectedBankID, cancellationReasons, cancelReason)}
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          {isCancelled && this.renderCancelActions()}
          {!isCancelled && isSold && <Label className="booking-sold-status-label">{t('All fields marked with an * are required')}</Label>}
          {!isCancelled && this.renderActionButtons()}
        </Modal.Actions>
      </Modal>
    );
  }
}

export default withTranslation([
  ...namespaces,
  TRANSLATION_FILES.models.booking,
])(connect(BookingStatusNotes.mapStateToProps)(BookingStatusNotes));



// WEBPACK FOOTER //
// ./src/containers/modals/BookingStatusNotes.jsx